<dialog #dialog class="apps-starter-dialog">
  <form method="dialog">
    <div class="scroll-area">
      @if (data | async; as appsStarter) {
        <div class="apps-grid">
          <!-- app item -->
          @for (item of appsStarter; track item.id) {
            <div class="app-item">
              <a [href]="item.url" target="_blank">
                @if (item.image) {
                  <app-image [alt]="item.title" [src]="item.icon | getImagePath: 56 : 56" [height]="56" [width]="56" />
                } @else {
                  <app-image [alt]="item.title" [src]="item.icon | getImagePath" [height]="56" [width]="56" />
                }
                <p>{{ item.title }}</p>
              </a>
            </div>
          }
        </div>
      } @else {
        <app-spinner />
      }
    </div>
    <button class="close-popup" type="submit">Schließen</button>
  </form>
</dialog>
